import { getIsUngatedForEditingTicketEmail, getHasEditTicketEmailScope } from 'EmailEditorUI/redux/selectors/AuthSelectors';
// @ts-expect-error module not yet migrated
import { getIsTicketEmail } from 'EmailEditorUI/redux/selectors/EmailSelectors';
import { createSelector } from 'reselect';
export const getIsEditableTicketEmail = createSelector([getIsUngatedForEditingTicketEmail, getHasEditTicketEmailScope, getIsTicketEmail], (isUngatedForTicketEmail, hasEditTicketEmailScope, isTicketEmail) => {
  return isUngatedForTicketEmail && hasEditTicketEmailScope && isTicketEmail;
});

// Email:EditingTicketEmail ->  delete this after ungating and replace with getIsTicketEmail
export const getIsUpdatedTicketEmail = createSelector([getIsUngatedForEditingTicketEmail, getIsTicketEmail], (isUngatedForTicketEmail, isTicketEmail) => {
  return isUngatedForTicketEmail && isTicketEmail;
});